"use client";
import {useEffect, useState} from 'react';
import {api} from '@/lib/api';
type MemberPrice = {premiumMember: boolean; bundleActive: boolean; memberPrice: {amount: number; regularAmount: number; savingsPercent: number; remaining: number; limit: number; early: boolean}};
export function useBiteMemberPrice() {
  const [value, setValue] = useState<MemberPrice | null>(null);
  const [error, setError] = useState(false), [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setError(false);
    api<MemberPrice>('/api/bite/stripe/plans', {signal: controller.signal, cache: 'no-store'})
      .then(setValue).catch(e => { if(e.name !== 'AbortError') setError(true); });
    return () => controller.abort();
  }, [attempt]);
  return {value, error, retry: () => setAttempt(v => v + 1), ready: value !== null};
}
